module.exports = __webpack_public_path__ + "media/Loops 110 Perc.f0796f3d.wav";